export default "__VITE_ASSET__DloJ6CWV__"